import Alpine from 'alpinejs';
import { postReview, REVIEW_SUBMIT_ERROR } from './review-helpers.js';

Alpine.store('avariReview', {
    step: 'form',
    rating: 0,
    review: '',
    loading: false,
    error: '',
    reservationId: '',
    listingTitle: '',
    streetAddress: '',
    locationLabel: '',
    dateRange: '',
    imageUrl: '',

    open(reservationId, details = {}) {
        this.step = 'form';
        this.rating = 0;
        this.review = '';
        this.loading = false;
        this.error = '';
        this.reservationId = reservationId || '';
        this.listingTitle = details.listingTitle || '';
        this.streetAddress = details.streetAddress || '';
        this.locationLabel = details.locationLabel || '';
        this.dateRange = details.dateRange || '';
        this.imageUrl = details.imageUrl || '';

        Alpine.store('modals').open('review-modal');
    },

    close() {
        Alpine.store('modals').close('review-modal');
    },

    setRating(value) {
        this.rating = value;
        this.error = '';
    },

    async submit() {
        if (this.rating === 0) {
            this.error = 'Please select a rating.';
            return;
        }

        if (!this.review.trim()) {
            this.error = 'Please write a review.';
            return;
        }

        this.loading = true;
        this.error = '';

        try {
            const data = await postReview(
                '/actions/avari/review/avari-submit',
                {
                    reservationId: this.reservationId,
                    rating: this.rating,
                    review: this.review
                }
            );

            if (data.success) {
                this.step = 'success';
            } else {
                this.error = data.error || REVIEW_SUBMIT_ERROR;
            }
        } catch {
            this.error = REVIEW_SUBMIT_ERROR;
        } finally {
            this.loading = false;
        }
    }
});
